import styled from 'styled-components';

export const DeliveryMethodRadioStyled = styled.div`
  display: flex;
  overflow-wrap: anywhere;
  word-break: break-word;
  flex-direction: row;
  padding: 0.5rem;
  border-radius: 0.75rem;
  user-select: none;
  margin-bottom: 0.5rem;
  .est-text {
    margin-left: 8px;
  }
  .Polaris-Text--root {
    font-size: 12px;
  }
  input {
    cursor: pointer;
  }
  .shipping-privacy-href:hover {
    color: ${(props) => props.color};
  }
`;
